import { useState, useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { testimonials } from '@/data/testimonials';

export default function TestimonialsCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    slidesToScroll: 3,
    align: 'start',
    containScroll: 'trimSnaps',
    breakpoints: {
      '(max-width: 768px)': { slidesToScroll: 1 },
    },
  });

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    onSelect();
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <section className="py-20 bg-warm-50">
      <div className="container-wide">
        <h2 className="text-center mb-12">Testimonials</h2>

        <div className="relative px-12">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex">
              {testimonials.map((t) => (
                <div
                  key={t.id}
                  className="flex-[0_0_100%] md:flex-[0_0_33.333%] min-w-0 px-4"
                >
                  <div className="text-center py-4">
                    <p className="text-warm-700 text-base leading-relaxed mb-6">
                      &ldquo;{t.quote}&rdquo;
                    </p>
                    <p className="font-semibold text-warm-900">-{t.author}-</p>
                    {t.organization && (
                      <p className="text-sm text-warm-500">{t.organization}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Prev arrow */}
          {canScrollPrev && (
            <button
              className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center text-warm-700 hover:bg-warm-100 transition-colors"
              onClick={() => emblaApi?.scrollPrev()}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}

          {/* Next arrow */}
          {canScrollNext && (
            <button
              className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center text-warm-700 hover:bg-warm-100 transition-colors"
              onClick={() => emblaApi?.scrollNext()}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
